export const showExtraColumns = (companyId) =>{
    const companyIds = [41,65,51,59,72,90,92];
    return companyIds.includes(companyId);
};
export const handlePrescribersHeading = (companyId) => {
    const companyIds = [18,20,34,37,41,51,53,59,140,150,64,66,233,72,90,92]; // need to remove 41 from here after sometime , 150 is for demo
    return companyIds.includes(companyId);
};
export const handleTopEngagersApiCall = (companyId) =>{
    const companyIds = [18,20,34,37,41,51,53,59,150,64,66,233,72,90,92]; // need to remove 41 from here after sometime
    return companyIds.includes(companyId);
};
export const handleIcons = (value) =>{
    if(value === 'High' || value === 'Match' || value === 'Matched') return { color: 'bg-success-100 success-500', icon: value === 'High' ? 'H' : 'M' };
    if(value === 'Medium' || value === 'Recommend' || value === 'Recommended') return { color: 'bg-medium-100 warning-500', icon: value === 'Medium' ? 'M' : 'R' };
    if(value === 'Low' || value === 'None') return { color: 'bg-error-100 error-500', icon: value === 'Low' ? 'L' : 'N' };
    return { color: 'bg-gray-100', icon: ' ' };
};

export const showDigitalEngagementPriorityData = (companyId) => {
    const companyIds = [51,53,59,72,90,92];
    return companyIds.includes(companyId);
};
